import { Sun, Moon } from "lucide-react";
import { useThemeStore } from "../stores/themeStore";

interface ThemeToggleProps {
  size?: number;
  className?: string;
}

export default function ThemeToggle({ size = 18, className = "" }: ThemeToggleProps) {
  const { isDark, toggleTheme } = useThemeStore();

  return (
    <button
      onClick={toggleTheme}
      className={`p-2 hover:bg-[var(--bg-tertiary)] transition-colors ${className}`}
      title={isDark ? "Modo claro" : "Modo oscuro"}
    >
      {isDark ? (
        <Sun size={size} className="text-[var(--text-secondary)]" />
      ) : (
        <Moon size={size} className="text-[var(--text-secondary)]" />
      )}
    </button>
  );
}
